import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof OrganizationReleaseNoteSetupService.props>

export default class OrganizationReleaseNoteSetupService extends BaseSetupService<Props> {
	static readonly props = {};

	private readonly state = reactive({ step: 'intro' });

	get step () { return this.state.step; }
	set step (val) { this.state.step = val; }

	get modalTitle () {
		return ['company-list', 'form'].includes(this.step)
			? `Création de votre organisation`
			: `Arrivée des organisations`;
	}

	constructor (props?: Props) {
		super(props);
	}
}
